import { Checkbox, Form } from 'antd';

import { ItemWrapper } from './ChooseCoursesChecker.styles';

import { Box } from '@/components/Utils';

type Props = {
  value: string;
  label: string;
  emoji?: string;
};

export const CourseCheckbox = ({ value, label, emoji = '🎓' }: Props) => {
  const form = Form.useFormInstance();
  const selected = Form.useWatch(['planification', 'subscriptions'], form) as string[] | undefined;
  const isSelected = Array.isArray(selected) ? selected.includes(value) : false;

  const toggleSelection = () => {
    const current = Array.isArray(selected) ? selected : [];
    const next = isSelected ? current.filter(v => v !== value) : [...current, value];
    form.setFieldsValue({ planification: { subscriptions: next } });
  };
  return (
    <ItemWrapper $isSelected={isSelected} onClick={toggleSelection}>
      <Checkbox value={value} checked={isSelected} onChange={toggleSelection}>
        <Box display="flex" alignItems="center" gap={12}>
          <span>{emoji}</span>
          <span>{label}</span>
        </Box>
      </Checkbox>
    </ItemWrapper>
  );
};
